module.exports = __webpack_public_path__ + "img/logo_12.656512d8.png";